export const TABLE_UPDATE = "ORDER_LOCATIONS/TABLE_UPDATE";
export const FETCH_SUCCESS = "ORDER_LOCATIONS/FETCH_SUCCESS";

const types = {
    FETCH_FAILED: "ORDER_LOCATIONS/FETCH_FAILED",
    FETCH_REQUEST: "ORDER_LOCATIONS/FETCH_REQUEST",
    FETCH_SUCCESS,

    MODULES_FETCH_FAILED: "ORDER_LOCATIONS/MODULES_FETCH_FAILED",
    MODULES_FETCH_REQUEST: "ORDER_LOCATIONS/MODULES_FETCH_REQUEST",
    MODULES_FETCH_SUCCESS: "ORDER_LOCATIONS/MODULES_FETCH_SUCCESS",

    DATATRANS_GATEWAY_FAILED: "ORDER_LOCATIONS/DATATRANS_GATEWAY_FAILED",
    DATATRANS_GATEWAY_REQUEST: "ORDER_LOCATIONS/DATATRANS_GATEWAY_REQUEST",
    DATATRANS_GATEWAY_SUCCESS: "ORDER_LOCATIONS/DATATRANS_GATEWAY_SUCCESS",

    GASTROPAY_CONFIGURE_FAILED: "ORDER_LOCATIONS/GASTROPAY_CONFIGURE_FAILED",
    GASTROPAY_CONFIGURE_REQUEST: "ORDER_LOCATIONS/GASTROPAY_CONFIGURE_REQUEST",
    GASTROPAY_CONFIGURE_SUCCESS: "ORDER_LOCATIONS/GASTROPAY_CONFIGURE_SUCCESS",

    GASTROPAY_GATEWAY_FAILED: "ORDER_LOCATIONS/GASTROPAY_GATEWAY_FAILED",
    GASTROPAY_GATEWAY_REQUEST: "ORDER_LOCATIONS/GASTROPAY_GATEWAY_REQUEST",
    GASTROPAY_GATEWAY_SUCCESS: "ORDER_LOCATIONS/GASTROPAY_GATEWAY_SUCCESS",

    GASTROPAY_REMOVE_FAILED: "ORDER_LOCATIONS/GASTROPAY_REMOVE_FAILED",
    GASTROPAY_REMOVE_REQUEST: "ORDER_LOCATIONS/GASTROPAY_REMOVE_REQUEST",
    GASTROPAY_REMOVE_SUCCESS: "ORDER_LOCATIONS/GASTROPAY_REMOVE_SUCCESS",

    GASTROPAY_UPDATE_FAILED: "ORDER_LOCATIONS/GASTROPAY_UPDATE_FAILED",
    GASTROPAY_UPDATE_REQUEST: "ORDER_LOCATIONS/GASTROPAY_UPDATE_REQUEST",
    GASTROPAY_UPDATE_SUCCESS: "ORDER_LOCATIONS/GASTROPAY_UPDATE_SUCCESS",

    GET_FAILED: "ORDER_LOCATIONS/GET_FAILED",
    GET_REQUEST: "ORDER_LOCATIONS/GET_REQUEST",
    GET_SUCCESS: "ORDER_LOCATIONS/GET_SUCCESS",
    TABLE_UPDATE,
};

export default types;
